export function getIsCalendarGridSecondaryLabelShown({
  isSecondaryLabelClickable,
  secondaryLabel,
}) {
  return isSecondaryLabelClickable || Boolean(secondaryLabel)
}
